import { CardSubtitle } from "../../types/CoreComponents";

export const DefaultFileUpload: CardSubtitle[] = [
  {
    text: "We use the create method to turn a",
    code: "<input type='file'>",
  },
  {
    text: " into a FilePond drop area.",
    code: "[https://pqina.nl/filepond/]",
  },
];

export const ImagePreviewData: CardSubtitle[] = [
  {
    text: "We use the create method to turn a",
    code: "<input type='file'>",
  },
  {
    text: " into a FilePond drop area.",
    code: "[https://pqina.nl/filepond/]",
  },
];

export const FileUploadData: CardSubtitle[] = [
  {
    text: "Use the ",
    code: ".dropzone ",
  },
  {
    text: "class through create upload files.",
    code: "[https://www.dropzone.dev/].",
  },
];
